<template>
    <div class="text-3xl lg:text-4xl font-bold text-center text-gray-900">
        <slot />
    </div>
</template>
